import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© 2025 ChronoTech Robotics</p>

        <p style={{ fontSize: '0.8rem', color: '#aaa', marginTop: '1rem' }}>
  Located in Silicon Valley, California.
</p>
<p>
  <a href="/privacy" className="footer-link">Privacy Policy</a> •{' '}
  <a href="/terms" className="footer-link">Terms of Service</a>
</p>


      </div>
    </footer>
  );
}
